import styles from "./styles/drop_down.module.scss";

interface Option {
  value: string;
  label: string;
}

export const DropDown: React.FC<{
  label?: string;
  name?: string;
  required?: boolean;
  width?: number | string;
  options: Option[];
  onChange?: (value: string) => void;
  value?: string;
}> = ({ label, name, value, required, width, options, onChange }) => {
  function handleSelection(event: React.ChangeEvent<HTMLSelectElement>) {
    const selectedValue = event.target.value;
    if (onChange) {
      onChange(selectedValue);
    }
  }

  return (
    <div className={styles.wrapper} style={{ width: width }}>
      {label && <label className={styles.label}>{label}</label>}
      <select
        className={styles.dropDown}
        name={name}
        required={required}
        onChange={handleSelection}
        value={value}
      >
        {options.map((option, index) => (
          <option key={index} className={styles.option} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
